var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{staticClass:"footer-text"},[_c('span',[_vm._v(" © 2021 by Australian Shepherd Club of America | "),_c('a',{attrs:{"href":"https://asca.org/privacy-policy/","target":"_blank"}},[_vm._v("Privacy Statement")]),_vm._v(" | "),_c('a',{attrs:{"href":"mailto:support@asca.org"}},[_vm._v("Contact Us")])])])
}]

export { render, staticRenderFns }